var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('editor',{key:_vm.tinymceFlag,ref:"tinymceEditor",attrs:{"id":"tinymce","init":_vm.init},on:{"input":_vm.onEditorInput},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }